import type { HTMLReactParserOptions } from "html-react-parser"
import type { ReactNode } from "react"

export type ContentProps = {
  path: string
  parserOptions?: HTMLReactParserOptions
  noParse?: boolean
  pipe?: string
  stripHtml?: boolean | string[]
  [key: string]:
    | string
    | string[]
    | boolean
    | ReactNode
    | HTMLReactParserOptions
    | string[]
    | undefined
}

export type UseContentProps = string | ContentProps

/** Normalises string or object props to `{ path, ...replacements }`. */
export function returnObjectWithPath<T extends UseContentProps>(props: T) {
  return (typeof props === "string" ? { path: props } : props) as T extends {
    noParse: true
  }
    ? ContentProps & { noParse: true }
    : ContentProps
}
